import styled from '@emotion/styled'
import { Button } from '@rebass/emotion'
import { MediaQueries as Mq } from '../../styles/settings/theme'
//import { Button } from 'rebass'
//^^ need to import from @rebass/emotion in order to use button variants

export const BaseButton = styled(Button)`
  border-radius: 50px;
  border: ${(props) => (props.border ? '1px solid white' : null)};
  cursor: pointer;
`
export const DonateButton = styled(BaseButton)`
  color: ${(props) => props.theme.colors.black};
  background-color: ${(props) => props.theme.colors.aqua};
  a {
    color: ${(props) => props.theme.colors.black};
    text-decoration: none;
  }

  &:hover {
    color: ${(props) => props.theme.colors.white};
  }
  ,
  &:focus {
    color: ${(props) => props.theme.colors.white};
  }
  font-size: ${(props) => (props.sm ? '.75rem' : '0.9rem')};
  padding: ${(props) => (props.sm ? '0px 8px 0px 8px' : '1px 10px 0px 10px')};
  height: ${(props) => (props.sm ? '1.1rem' : '1.4rem')};
`
export const BackButton = styled(BaseButton)`
  display: flex;
  align-items: center;
  font-size: 0.7rem;
  font-weight: 400;
  text-transform: uppercase;
  background-color: transparent;
  font-family: ${(props) => props.theme.fonts.condensed};
`
export const BigRedButton = styled(BaseButton)`
  color: ${(props) => props.theme.colors.white};
  background-color: ${(props) => props.theme.colors.red};
  font-family: ${(props) =>
    props.ui === 'en' ? props.theme.fonts.condensed : 'Arial, sans-serif'};
  font-size: 1rem;
  text-transform: ${(props) => (props.ui === 'en' ? 'uppercase' : 'none')};
  letter-spacing: ${(props) => (props.ui === 'en' ? '0.15rem' : 0)};
  padding: 10px 14px 4px;
  &:hover {
    background-color: ${(props) => props.theme.colors.darkRed};
  }
  &:focus {
    background-color: ${(props) => props.theme.colors.darkRed};
  }

  ${Mq.md} {
    padding: 12px 24px 8px;
    font-size: 1.25rem;
    letter-spacing: ${(props) => (props.ui === 'en' ? '0.2rem' : 0)};
  }
`
export const TransparentButton = styled(BaseButton)`
  color: ${(props) => props.theme.colors.white};
  background-color: transparent;
  width: ${(props) =>
    props.small && props.ui === 'en'
      ? '3.75rem'
      : props.small && props.ui === 'fa'
      ? '6rem'
      : 'auto'};
  padding: ${(props) => (props.small ? '0px 5px' : '4px 16px 0px')};
  font-family: ${(props) =>
    props.small
      ? 'Arial, sans-serif'
      : props.ui === 'en'
      ? props.theme.fonts.condensed
      : 'Arial, sans-serif'};
  font-size: ${(props) => (props.small ? '.75rem' : '1rem')};
  text-transform: ${(props) =>
    props.small ? 'none' : props.ui === 'en' ? 'uppercase' : 'none'};
  letter-spacing: ${(props) =>
    props.small ? 'normal' : props.ui === 'en' ? '0.2rem' : 0};
  a {
    color: ${(props) => props.theme.colors.white};
    text-decoration: none;
  }
  &:hover {
    background-color: ${(props) => props.theme.colors.aqua};
  }
  // &:focus {
  //   background-color: ${(props) => props.theme.colors.aqua};
  // }
  &:active {
    background-color: ${(props) => props.theme.colors.white};
  }
  margin-right: 0 0.5rem;
  ${Mq.xs} {
    margin-top: ${(props) =>
      props.intro === 'open' && props.small ? 0 : props.small ? '.5rem' : 0};
  }
`
